import { useDispatch, useSelector } from "react-redux";
import styled, { css, keyframes } from "styled-components";
import { selectIfCardFormShown } from "../checkout/checkoutSlice";
import { selectShowPaywall, setShowMap, setShowPaywall } from "./plansSlice";
import { selectLoadStatus } from "./map/mapSlice";

const CrossIcon = (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.41413 6.00001L11.7071 1.70701C12.0981 1.31601 12.0981 0.684006 11.7071 0.293006C11.3161 -0.0979941 10.6841 -0.0979941 10.2931 0.293006L6.00013 4.58601L1.70713 0.293006C1.31613 -0.0979941 0.684128 -0.0979941 0.293128 0.293006C-0.0978721 0.684006 -0.0978721 1.31601 0.293128 1.70701L4.58613 6.00001L0.293128 10.293C-0.0978721 10.684 -0.0978721 11.316 0.293128 11.707C0.488128 11.902 0.744128 12 1.00013 12C1.25613 12 1.51213 11.902 1.70713 11.707L6.00013 7.41401L10.2931 11.707C10.4881 11.902 10.7441 12 11.0001 12C11.2561 12 11.5121 11.902 11.7071 11.707C12.0981 11.316 12.0981 10.684 11.7071 10.293L7.41413 6.00001Z"
      fill="#323232"
    />
  </svg>
);

const fadeIn = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1;}
`;

const fadeInDelay = css`
  animation-name: ${fadeIn};
  animation-duration: 1s;
  animation-delay: 5s;
  animation-fill-mode: forwards;
`;

const StyledCross = styled.button`
  position: absolute;
  width: 40px;
  height: 40px;
  padding: 6px;
  top: 35px;
  right: 0;
  ${(props) => !props.cardFormVisited && fadeInDelay};
  border: none;
  background-color: transparent;
  opacity: ${(props) => (props.cardFormVisited ? "1" : "0")};

  svg {
    width: 12px;
    height: 12px;
    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }

  &:focus {
    outline: none;
  }
`;

const CrossBtn = () => {
  const cardFormVisited = useSelector(selectIfCardFormShown);
  const dispatch = useDispatch();
  const showPaywall = useSelector(selectShowPaywall);
  const status = useSelector(selectLoadStatus);

  return (
    status && (
      <StyledCross
        cardFormVisited={cardFormVisited}
        onClick={
          showPaywall
            ? () => dispatch(setShowPaywall(false))
            : () => dispatch(setShowMap(true))
        }
        id={"paywall-skip-button"}
      >
        {CrossIcon}
      </StyledCross>
    )
  );
};

export default CrossBtn;
